import React, { memo, useState } from 'react'
import { Container, HorizontalScroll, Card, HeadingText } from '@paypalcorp/pp-react'
import {
  otherPageConfig,
  constructConfigForSection,
  homeConfig
} from '../../config/privacy-hub'
import Section from '../../components/privacyHub/section'
import { Message } from '@paypalcorp/worldready-react'
import { PrivacyHubLink } from './common'
import PrivacyHubHeader from '../../components/privacyHub/privacy-hub-header'


const itemConfig = (lists,id,className,)=>{
  return lists?.map((listItem, index) => {
    return {
      description: {
        class: className,
        id: `${id}_desc${index}`,
        messageId: listItem,
        size: 'sm',
      },
    }
  })
}

const carouselTile = ({ title, desc, lists, svg_icon, id, enabled,className,descriptionLink,content }) => {
  return (
    <>
      {enabled && (
        <div className="privacy-hub-carousel-tile">
          {
            <Card className={`privacy-hub-card ${className}`}>
              <Section
                {...constructConfigForSection('Card_section', {
                descriptionList : itemConfig(lists,id,'privacy-hub-description privacy-hub-text'),
                  title: desc,
                  heading: {
                    size: 'sm',
                    class:
                      'privacy-hub-text privacy-hub-card-heading privacy-hub-heading-description-text ',
                    id: `${id}_Title`,
                    messageId: title.messageId,
                  },
                  Content:content,
                  icon_svg_link: {
                    imgSrc: svg_icon.src,
                    imgClass: svg_icon.class,
                    alt: id,
                  },
                })}
              >
                {descriptionLink && <PrivacyHubLink {...descriptionLink}/>}
              </Section>
            </Card>
          }
        </div>
      )}
    </>
  )
}

const PrivcyHubOthersSection = memo(() => {

  return(
  <>
    <Container className="privacy-hub-section-container">
      <div className="privacy-hub-wrapper">
      <PrivacyHubHeader {...homeConfig.headerSection('others')}/>
      </div>
    </Container>
  </>
)})

PrivcyHubOthersSection.displayName = 'PrivacyHubOthersSection'

const PrivacyHubPayOrGetPaidSection = memo(() => {
  const [currentPage, setCurrentPage] = useState(1)

  const handlePageChange = (index) => {
    setCurrentPage(index)
  }

  return (
    <Container className={`privacy-hub-section-container `}>
      <div className="privacy-hub-wrapper">
        <div className={`privacy-hub-horizontal-scroll-container`}>
            <HeadingText size="lg" className='privacy-hub-text privacy-hub-section-main-heading' id ='privacy-hub-section-others-see-title'>
                  <Message id= 'privacyhub.home.otherssee.payOrGetPaid'/>
            </HeadingText>
          {currentPage && (
            <div className='privacy-hub-carousel-container'>
            <HorizontalScroll
              items={otherPageConfig.whenYouPayOrGetPaid.filter(
                (items) => items.enabled,
              )}
              renderItem={carouselTile}
              numOfVisibleItems={2}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
            </div>
          )}
        </div>
      </div>
    </Container>
  )
})

PrivacyHubPayOrGetPaidSection.displayName = 'PrivacyHubPayOrGetPaidSection'

const PrivacyHubWhenYouShopSection = memo(() => {
  const { enabled, title, heading, lists, subHeading, svg_icon, id } =
    otherPageConfig.whenYouShopData

  return (
    <div className={`privacy-hub-section-container privacy-hub-when-you-shop-card`}>
      {enabled && (
        <Container
          fluid
          className="privacy-hub-card privacy-hub-card-last"
        >
          <div className="privacy-hub-wrapper">
            <Container className={`privacy-hub-section-container-wrapper`}>
              <Section
                {...constructConfigForSection('Card_section', {
                  descriptionList: lists?.map((listItem, index) => {
                    return {
                      description: {
                        class: 'privacy-hub-description privacy-hub-text',
                        id: `${id}_desc${index}`,
                        messageId: listItem,
                        size: 'sm',
                      },
                    }
                  }),
                  heading,
                  subHeading,
                  colAlign:true,
                  title,
                  icon_svg_link: {
                    imgSrc: svg_icon.src,
                    imgClass: svg_icon.class,
                    alt: svg_icon.alt,
                  },
                })}
              />
            </Container>
          </div>
        </Container>
      )}
    </div>
  )
})

PrivacyHubWhenYouShopSection.displayName = 'PrivacyHubWhenYouShopSection'

const PrivacyHubWhenYouLinkYourCardSection = memo(() => {
  const { enabled, subHeading, heading, lists, id, svg_icon } = otherPageConfig
    .LinkBanksAndCardsData[0].enabled
    ? otherPageConfig.LinkBanksAndCardsData[0]
    : otherPageConfig.LinkBanksAndCardsData[1]
  return (
    <>
      {enabled && (
        <Container className={`privacy-hub-section-container privacy-hub-add-a-bank-account`}>
          <div className="privacy-hub-wrapper">
            <Section
              {...constructConfigForSection('Card_section', {
                descriptionList: itemConfig(lists,id,'privacy-hub-text'),
                order: 1,
                heading,
                subHeading,
                colAlign:true,
                icon_svg_link: {
                  imgSrc: svg_icon.src,
                  imgClass: svg_icon.class,
                  alt: svg_icon.alt,
                },
              })}
            />
          </div>
        </Container>
      )}
    </>
  )
})

PrivacyHubWhenYouLinkYourCardSection.displayName =
  'PrivacyHubWhenYouLinkYourCardSection'

const PrivacyHubOthers = memo(() => (
  <div id="privacy-hub-others">
    <PrivcyHubOthersSection />
    <PrivacyHubPayOrGetPaidSection />
    <PrivacyHubWhenYouShopSection />
    <PrivacyHubWhenYouLinkYourCardSection />
  </div>
))
PrivacyHubOthers.displayName = 'PrivacyHubOthers'
export default PrivacyHubOthers
